import { render, staticRenderFns } from "./ServiceBookings.vue?vue&type=template&id=70a9a305&"
import script from "./ServiceBookings.vue?vue&type=script&lang=js&"
export * from "./ServiceBookings.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/admin_service_bookings.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports